// Styles
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for ContainerSettingsForm component
 */ export const useContainerSettingsFormStyles = makeStyles({
    container: {
        ...flexParent("column"),
        ...shorthands.gap(tokens.spacingVerticalL)
    }
});
